import type { TransportOrderDetail } from 'api/generated/transportOrdersApi';
import OrderEtaLabel from 'components/OrderEtaLabel';
import {
    formatDistance,
    formatDuration,
    getSummaryDurationSeconds,
    getSummaryStatus,
    getSummaryTime,
    ORDER_STATUS_TEXT_COLOR,
} from 'utils/transportOrder';

export type TransportOrderDetailSummaryProps = {
    order: TransportOrderDetail;
};

const TransportOrderDetailSummary = ({ order }: TransportOrderDetailSummaryProps) => {
    const status = getSummaryStatus(order);

    if (status === undefined) {
        return null;
    }

    const isDelivered = order.deliveredAt !== undefined;
    const timeAt = getSummaryTime(order, status);
    const durationSeconds = getSummaryDurationSeconds(order, status);
    const distanceMeters = isDelivered
        ? order.routeInfo?.totalDistanceMeters
        : order.progressDetails?.remainingDistanceMeters;

    const distance =
        distanceMeters === undefined
            ? undefined
            : `${formatDistance(distanceMeters)} ${isDelivered ? 'total' : 'left'}`;
    const duration =
        durationSeconds === undefined
            ? undefined
            : `${formatDuration(durationSeconds)}${isDelivered ? '' : ' remaining'}`;

    const headline = duration ?? distance;

    if (headline === undefined) {
        return null;
    }

    return (
        <div className='display-flex align-items-center gap-15 margin-top-15'>
            <OrderEtaLabel status={status} etaAt={timeAt} />
            <div>
                <div className={`text-size-h3 ${ORDER_STATUS_TEXT_COLOR[status]}`}>{headline}</div>
                {duration === undefined || distance === undefined ? null : (
                    <div className='text-size-14 text-color-dark'>{distance}</div>
                )}
            </div>
        </div>
    );
};

export default TransportOrderDetailSummary;
